import { render, staticRenderFns } from "./ReportsTabs.vue?vue&type=template&id=e37971b6&scoped=true"
import script from "./ReportsTabs.vue?vue&type=script&lang=js"
export * from "./ReportsTabs.vue?vue&type=script&lang=js"
import style0 from "./ReportsTabs.vue?vue&type=style&index=0&id=e37971b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37971b6",
  null
  
)

export default component.exports